export default __webpack_public_path__ + "static/crm_process-9a64070377f3bcb978c007be471d2a7b.webp";